
import React from 'react';
import { Link } from 'react-router-dom';

interface CTASectionProps {
  title?: string;
  subtitle?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  bgColor?: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title = "Ready to Start Your Electrical Project?",
  subtitle = "Contact us today for a free quote. Our team of experts is standing by to help with all your electrical needs in Lake Helen and surrounding areas.",
  primaryButtonText = "Get a Free Quote",
  primaryButtonLink = "/contact",
  secondaryButtonText = "Browse Our Services",
  secondaryButtonLink = "/services",
  bgColor = "bg-navy"
}) => {
  return (
    <section className={`py-16 ${bgColor}`}>
      <div className="container-custom text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-white mb-4">{title}</h2>
          <p className="text-white/80 text-lg mb-8">{subtitle}</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to={primaryButtonLink} className="btn-primary">
              {primaryButtonText}
            </Link>
            <Link to={secondaryButtonLink} className="btn-outline border-white text-white hover:bg-white hover:text-navy">
              {secondaryButtonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
